var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.01,
    height: 72.688,
    viewBox: "0 0 57.01 72.688"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "play_svg__a",
    d: "M0 0v72.688l57.01-36.344z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1Ny4wMSIgaGVpZ2h0PSI3Mi42ODgiIHZpZXdCb3g9IjAgMCA1Ny4wMSA3Mi42ODgiPjxwYXRoIGNsYXNzPSJhIiBkPSJNNi43NSwzLjY1NlY3Ni4zNDRMNjMuNzYsNDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi43NSAtMy42NTYpIi8+PC9zdmc+";
export { SvgPlay as ReactComponent };